import { render } from "./VideoBanner.vue?vue&type=template&id=5d923151&scoped=true"
import script from "./VideoBanner.vue?vue&type=script&lang=js"
export * from "./VideoBanner.vue?vue&type=script&lang=js"

import "./VideoBanner.vue?vue&type=style&index=0&id=5d923151&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d923151"]])

export default __exports__